import { ReactNode } from 'react';
import { Card } from '@fluentui/react-components';
import { ArrowTrendingLines24Regular } from '@fluentui/react-icons';

interface MetricsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: {
    value: number;
    direction: 'up' | 'down';
  };
  icon?: ReactNode;
  loading?: boolean;
}

export function MetricsCard({
  title,
  value,
  subtitle,
  trend,
  icon,
  loading = false,
}: MetricsCardProps) {
  if (loading) {
    return (
      <Card className="p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-20 rounded w-24 mb-4"></div>
          <div className="h-8 bg-gray-20 rounded w-32 mb-2"></div>
          <div className="h-3 bg-gray-20 rounded w-20"></div>
        </div>
      </Card>
    );
  }

  return (
    <div className="bg-white p-[25px] rounded shadow-card text-center">
      {icon && (
        <div className="w-10 h-10 mx-auto mb-[15px] opacity-80 text-salesforce-blue flex items-center justify-center">
          {icon}
        </div>
      )}

      <div className="text-[11px] uppercase text-gray-400 tracking-[0.5px] mb-[10px] font-medium">
        {title}
      </div>

      <div className="mb-2">
        <span className="text-[28px] font-semibold text-dark-text">{value}</span>
      </div>

      {subtitle && (
        <div className="text-xs text-gray-300 mb-2">{subtitle}</div>
      )}

      {trend && (
        <div
          className={`flex items-center justify-center gap-1 text-sm ${
            trend.direction === 'up'
              ? 'text-success-green'
              : 'text-error-red'
          }`}
        >
          <ArrowTrendingLines24Regular
            className={trend.direction === 'down' ? 'rotate-180' : ''}
          />
          <span>{Math.abs(trend.value).toFixed(1)}%</span>
          <span className="text-gray-300 ml-1 text-xs">vs. last period</span>
        </div>
      )}
    </div>
  );
}
